// Banks Mutations

export const updateBanksList = (state, payload) => {
  state.banksList = payload
}

export const setFullBanksList = (state, payload) => {
  state.fullBanksList = payload
}

export const setBankInfo = (state, payload) => {
  state.bankInfo = payload
}
